document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll('.cmg-filter-tab');
  const cards = document.querySelectorAll('.cmg-article-card');
  const countEl = document.getElementById('cmg-count');
  const clearBtn = document.getElementById('cmg-clear');
  const loadMoreBtn = document.getElementById('cmg-load-more');

  // Read initial count from schema (passed via data attribute)
  const sectionEl = document.querySelector('.cmg-section[data-initial-count]');
  const desktopInitialCount = sectionEl ? parseInt(sectionEl.getAttribute('data-initial-count'), 10) || 9 : 9;

  function getSettings() {
    const isMobile = window.innerWidth <= 768;
    return {
      initialCount: isMobile ? 4 : desktopInitialCount,
      increment: isMobile ? 4 : desktopInitialCount
    };
  }

  // Read URL params on load
  const urlParams = new URLSearchParams(window.location.search);
  const initialFilter = urlParams.get('filter');

  let activeFilter = null;
  let shownCount = getSettings().initialCount; // how many visible cards are currently shown

  function updateGrid() {
    let visibleCount = 0;
    let visibleCards = [];

    // 1st pass: determine which cards match the filter
    cards.forEach(card => {
      const tags = card.getAttribute('data-tags');
      let matchesFilter = true;
      if (activeFilter) {
        matchesFilter = tags && tags.includes(activeFilter);
      }

      // Remove all display-control classes first
      card.classList.remove('hide-card', 'load-more-hidden', 'no-border-right', 'no-border-bottom');

      if (matchesFilter) {
        visibleCards.push(card);
        visibleCount++;
      } else {
        card.classList.add('hide-card');
      }
    });

    // 2nd pass: apply load-more truncation on visible cards
    visibleCards.forEach((card, index) => {
      if (index >= shownCount) {
        card.classList.add('load-more-hidden');
      }
    });

    // Update count display (shows total matching, regardless of load more)
    if (countEl) countEl.textContent = visibleCount;

    // Show/hide/update Load More button
    if (loadMoreBtn) {
      const loadMoreText = loadMoreBtn.getAttribute('data-load-more') || 'Scopri altri articoli';
      const loadLessText = loadMoreBtn.getAttribute('data-load-less') || 'Mostra meno';

      const settings = getSettings();
      if (visibleCount <= settings.initialCount) {
        // No need for a button if everything fits within the initial count
        loadMoreBtn.classList.add('hidden');
      } else {
        loadMoreBtn.classList.remove('hidden');
        if (shownCount < visibleCount) {
          loadMoreBtn.textContent = loadMoreText;
        } else {
          loadMoreBtn.textContent = loadLessText;
        }
      }
    }

    // Recalculate borders on truly visible (not load-more-hidden) cards
    const shownCards = visibleCards.slice(0, shownCount);
    const shownTotal = shownCards.length;

    let cols = 3;
    if (window.innerWidth <= 900 && window.innerWidth > 600) cols = 2;
    if (window.innerWidth <= 600) cols = 1;

    shownCards.forEach((card, index) => {
      const totalRows = Math.ceil(shownTotal / cols);
      const currentRow = Math.ceil((index + 1) / cols);
      if ((index + 1) % cols === 0) card.classList.add('no-border-right');
      if (currentRow === totalRows) card.classList.add('no-border-bottom');
    });

    // Clear button state
    if (clearBtn) {
      if (activeFilter) {
        clearBtn.classList.add('is-active');
      } else {
        clearBtn.classList.remove('is-active');
      }
    }
  }

  function setFilter(filterVal) {
    if (activeFilter === filterVal) {
      activeFilter = null;
      window.history.replaceState(null, '', window.location.pathname);
    } else {
      activeFilter = filterVal;
      window.history.replaceState(null, '', `?filter=${filterVal}`);
    }

    // Reset shown count when filter changes
    shownCount = getSettings().initialCount;

    const filtersContainer = document.getElementById('cmg-filters');

    // Update Tabs UI
    tabs.forEach(tab => {
      if (tab.getAttribute('data-filter') === activeFilter) {
        tab.classList.add('active-filter');
      } else {
        tab.classList.remove('active-filter');
      }
    });

    if (activeFilter) {
      if (filtersContainer) filtersContainer.classList.add('has-active-tab');
    } else {
      if (filtersContainer) filtersContainer.classList.remove('has-active-tab');
    }

    updateGrid();
  }

  // Load More button click: toggle expand / collapse
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', () => {
      // Find out current visible count
      let visibleCount = 0;
      cards.forEach(card => {
        const tags = card.getAttribute('data-tags');
        let matchesFilter = true;
        if (activeFilter) {
          matchesFilter = tags && tags.includes(activeFilter);
        }
        if (matchesFilter) {
          visibleCount++;
        }
      });

      const settings = getSettings();

      if (shownCount < visibleCount) {
        // Expand
        shownCount += settings.increment; 
      } else {
        // Collapse
        shownCount = settings.initialCount;
        // Smooth scroll to top of magazine grid section
        if (sectionEl) {
          sectionEl.scrollIntoView({ behavior: 'smooth' });
        }
      }
      updateGrid();
    });
  }

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      setFilter(tab.getAttribute('data-filter'));
    });
  });

  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      setFilter(null);
    });
  }

  // Init
  if (initialFilter) {
    setFilter(initialFilter.toLowerCase());
  } else {
    updateGrid();
  }

  window.addEventListener('resize', () => {
    const currentInitial = getSettings().initialCount;
    if (shownCount < currentInitial) {
      shownCount = currentInitial;
    }
    updateGrid();
  });
});
